
import store from './index'
export default {
  setAuthentication (state, authentication) {
    if (!authentication) {
      store.commit('user/clear')
    }
    state.authenticated = authentication
  },
  coverIframes (state, status) {
    state.coverIframes = status
  },
  setFullscreenIframe (state, value) {
    state.fullscreenIframe = value
  },
  setInitialPath (state, path) {
    state.initialPath = path
  },
  setOnViz (state, value) {
    state.onViz = !!value
  },
  setOnAiDash (state, value) {
    state.onAiDash = !!value
  },
  setConnected (state, value) {
    state.connected = value
  },
  setNewVersionAvailable (state, value) {
    state.newVersionAvailable = value
  },
  setDeauthenticatedEvent (state, data) {
    state.deauthenticatedEvent.triggered = true
    state.deauthenticatedEvent.message = data.message
  },
  clearDeauthenticatedEvent (state) {
    state.deauthenticatedEvent.triggered = false
    state.deauthenticatedEvent.message = ''
  },
  setDrawer(state, value) {
    state.drawer = value;
  },
  setRail(state, value) {
    state.rail = value;
  },
  setNewStartMessage(state, value) {
    state.newStartMessage = value;
  },
  clearNewStartMessage(state, value) {
    state.newStartMessage = '';
  },
}
